import { render, staticRenderFns } from "./gj-alert.vue?vue&type=template&id=270c4970&scoped=true&"
import script from "./gj-alert.vue?vue&type=script&lang=js&"
export * from "./gj-alert.vue?vue&type=script&lang=js&"
import style0 from "./gj-alert.vue?vue&type=style&index=0&id=270c4970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270c4970",
  null
  
)

export default component.exports